module.exports = {
      id: "clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }